import React, { useState, useEffect } from "react";
import styles from "./Business.module.scss";
import { useParams, useHistory } from "react-router";
import {
  ToastSuccessStyles,
  ToastErrorStyles,
} from "../../../constants/toastStyles";
import { useDispatch } from "react-redux";
import { openToastAndSetContent } from "../../../redux/actions/toast/toastActions";
import { Divider } from "@mui/material";
import Grid from "@mui/material/Grid";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import StatusView from "../../../components/StatusView/StatusView";
import { ReactComponent as Exclaim } from "../../../assets/images/Icons/u_exclaim.svg";
import Checkbox from "@mui/material/Checkbox";
import ViewFile from "./ViewFile";
import Verify from "./Verify";
import ViewDetails from "./ViewDetails";
import Modal from "react-modal";
import {
  computeCustomStyles,
  customStyles,
  viewDetailsModalStyles,
} from "../../../constants/modalStyles";
import UpdateDetailModal from "./UpdateDetailModal";
import SubsidiaryConfigSection from "./SubsidiaryConfigSection";
import UpdateSubsidiaryConfigModal from "../../../components/ModalContent/UpdateSubsidiaryConfigModal/UpdateSubsidiaryConfigModal";
import useApi from "../../../hooks/useApi";
import transactionsApi from "../../../api/subsidiaries";
import { numberWithCommas } from "../../../utils/formatNumber";
import SubsidiaryPreferenceSection from "./SubsidiaryPreferenceSection";
import UploadAdditionalDocument from "./UploadAdditionalDocument";
import { camelToTitle } from "../../../utils/commonHelper";

const BusinessDetails = () => {
  // const [businessDetails, setBusinessDetails] = useState<any>([]);
  const { id } = useParams<{ id: any }>();
  const [isLoading, setIsLoading] = useState(false);
  const [isViewDetails, setIsViewDetails] = React.useState(false);
  const [modalIsOpenSingle, setIsOpenSingle] = React.useState(false);
  const [documentModalIsOpenSingle, setdocumentModalIsOpenSingle] =
    React.useState(false);
  const [openCustomizeConfigModal, setOpenCustomizeConfigModal] =
    React.useState<any>(false);
  const [openDetailsUpdateModal, setOpenDetailsUpdateModal] =
    React.useState<any>({
      isOpen: false,
      fieldName: "",
      currentValue: "",
    });
  function closeModalSingle() {
    setIsOpenSingle(false);
  }

  function closeDocumentModalSingle() {
    setdocumentModalIsOpenSingle(false);
  }

  const fetchSubsidiaryConfigs = useApi(
    transactionsApi.getSubsidiaryCustomizeConfig
  );
  const fetchSubdiaryDetails = useApi(transactionsApi.getSubsidiaryDetails);
  const groupConfigInformation: any = fetchSubsidiaryConfigs?.data?.data || {};
  const businessDetails = fetchSubdiaryDetails?.data?.data ?? {};

  function closeDetailsUpdateModal(message?: string, err?: string) {
    setOpenDetailsUpdateModal({ isOpen: false, fieldName: "" });
    if (message) {
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastSuccessStyles,
          toastContent: message,
        })
      );
      fetchDetails();
    }
    if (err) {
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: err,
        })
      );
    }
  }
  const dispatch = useDispatch();
  const history = useHistory();

  const [list, setList] = useState({
    profile: true,
    bank: true,
    businessReg: true,
    contact: true,
    director: true,
    agreement: true,
    eightList: true,
    seventhList: true,
    subPreference: true,
  });

  //update the default state with backend response
  const [accepted, setAccepted] = useState(false);

  const fetchDetails = () => {
    id && fetchSubdiaryDetails.request(id);
    // id && fetchSubsidiaryConfigs.request(id);
  };

  useEffect(() => {
    fetchDetails();
  }, [id]);

  const {
    profileCompliance,
    bankCompliance,
    businessRegistrationCompliance,
    contactCompliance,
    directorOrOwnerCompliance,
    agreementCompliance,
  } = businessDetails;

  const profileComplianceObj = {
    businessTypeEnum: profileCompliance?.businessTypeEnum,
    businessTypeId: profileCompliance?.businessType?.id,
    businessType: profileCompliance?.businessType?.name,
    status: profileCompliance?.status,
    businessName: profileCompliance?.businessName,
    businessDescription: profileCompliance?.businessDescription,
    registrationNumber: profileCompliance?.registrationNumber,
    taxIdNumber: profileCompliance?.taxIdNumber,
    isBusinessVerified: profileCompliance?.isBusinessVerified,
    compliancePercentage: profileCompliance?.compliancePercentage,
  };

  const directorOrOwnerComplianceObj = {
    bvn: directorOrOwnerCompliance?.bvn,
    fullName: directorOrOwnerCompliance?.fullName,
    isBvnVerified: directorOrOwnerCompliance?.isBvnVerified,
    uploadedDocumentId: directorOrOwnerCompliance?.uploadedDocument?.id,
    uploadedDocumentName: directorOrOwnerCompliance?.uploadedDocument?.name,
    compliancePercentage: directorOrOwnerCompliance?.compliancePercentage,
  };

  function isImageFile(filename: string) {
    if (typeof filename !== "string") return false;

    const imageExtensions = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".bmp",
      ".webp",
      ".svg",
      ".tiff",
      ".ico",
    ];

    // Remove query params and fragments
    const cleanFilename = filename.split("?")[0].split("#")[0].toLowerCase();

    return imageExtensions.some((ext) => cleanFilename.endsWith(ext));
  }

  interface DynamicComplianceSectionProps<T extends Record<string, boolean>> {
    title: string;
    data: Record<string, any>;
    sectionKey: keyof T & string;
    list: T;
    setList: React.Dispatch<React.SetStateAction<T>>;
  }

  const DynamicComplianceSection = <T extends Record<string, boolean>>({
    title,
    data,
    sectionKey,
    list,
    setList,
  }: DynamicComplianceSectionProps<T>) => (
    <div className={styles.detailBox}>
      <div className={styles.detailBoxCorner}>
        <h3 className={styles.detailh3}>{title}</h3>
        <div
          onClick={() => setList({ ...list, [sectionKey]: !list[sectionKey] })}
          className={styles.detailicon}
        >
          {list[sectionKey] ? <AddIcon /> : <CloseIcon />}
        </div>
      </div>
      <Divider style={{ color: "#CECECD" }} />
      <div
        style={{ padding: "0 24px", display: list[sectionKey] ? "" : "none" }}
      >
        <Grid container spacing={2}>
          {data &&
            typeof data === "object" &&
            Object.keys(data).length > 0 &&
            Object.entries(data).map(([key, value]) =>
              !isImageFile(value) ? (
                <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
                  <div className={styles.customerInfo}>
                    <div className={styles.detailsValue}>
                      {camelToTitle(key)}
                    </div>
                    {String(key).toLocaleLowerCase() === "status" ? (
                      <StatusView
                        status={String(value) || "Not Provided"}
                        blue='Pending-Verification'
                        orange='Pending-Approval'
                        green='Active'
                        red='New'
                      />
                    ) : (
                      <div className={styles.detailsKey}>
                        {value !== undefined && value !== null && value !== ""
                          ? String(value) === "false"
                            ? "No"
                            : String(value) === "true"
                            ? "Yes"
                            : String(value)
                          : "Not Provided"}
                      </div>
                    )}
                  </div>
                </Grid>
              ) : (
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <div className={styles.customerInfo}>
                    <div className={styles.detailsValue}>
                      {camelToTitle(key)}
                    </div>
                    <div className={styles.detailsKey}>
                      <ViewFile name={String(value)} file={String(value)} />
                    </div>
                  </div>
                </Grid>
              )
            )}
        </Grid>
      </div>
    </div>
  );

  return (
    <div>
      {isLoading ? (
        <div />
      ) : (
        <div>
          <div className={styles.transactionsHeader}>
            <div
              style={{
                color: "#211F01",
                display: "inline",
                cursor: "pointer",
                fontWeight: "800px",
              }}
              onClick={() => history.goBack()}
            >
              <ArrowBackIosIcon sx={{ fontSize: "20px" }} /> Business Details
            </div>
            <div className={styles.buttonWrapper}>
              <button
                onClick={() =>
                  setOpenDetailsUpdateModal({
                    isOpen: true,
                    fieldName: "status",
                    // currentValue: businessInformation?.status,
                    currentValue: "status",
                  })
                }
                className={styles.downloadbutton}
              >
                Update Merchant Status
              </button>
              <button
                onClick={() => setIsOpenSingle(true)}
                className={styles.downloadbutton}
              >
                Verify Merchant
              </button>
              {profileComplianceObj?.businessType?.toLowerCase() ===
                "registered business" && (
                <button
                  onClick={() => setIsViewDetails(!isViewDetails)}
                  className={styles.verifyDetails}
                >
                  View Details
                </button>
              )}
            </div>
          </div>
          <DynamicComplianceSection
            title='Profile Compliance'
            data={profileComplianceObj}
            sectionKey='profile'
            list={list}
            setList={setList}
          />
          <DynamicComplianceSection
            title='Bank Compliance'
            data={bankCompliance}
            sectionKey='bank'
            list={list}
            setList={setList}
          />
          <DynamicComplianceSection
            title='Business Registration Compliance'
            data={businessRegistrationCompliance}
            sectionKey='businessReg'
            list={list}
            setList={setList}
          />
          <DynamicComplianceSection
            title='Contact Compliance'
            data={contactCompliance}
            sectionKey='contact'
            list={list}
            setList={setList}
          />
          <DynamicComplianceSection
            title='Director/Owner Compliance'
            data={directorOrOwnerComplianceObj}
            sectionKey='director'
            list={list}
            setList={setList}
          />
          <DynamicComplianceSection
            title='Agreement Compliance'
            data={agreementCompliance}
            sectionKey='agreement'
            list={list}
            setList={setList}
          />
          {/* <div className={styles.detailBox}>
            <div className={styles.detailBoxCorner}>
              <h3 className={styles.detailh3}>
               Fees & Limit Configurations Group ( {groupInformation?.name} ) 
     
                <button
                  onClick={() =>
                    setOpenDetailsUpdateModal({
                      isOpen: true,
                      fieldName: "subsidiaryGroupId",
                      // currentValue: groupInformation?.id,
                      currentValue: "",
                    })
                  }
                  className={styles.updateButton}
                >
                  Update Configuration Group
                </button>
                <button
                  onClick={() => setOpenCustomizeConfigModal(true)}
                  className={styles.configureNewGroup}
                >
                  Configure New Group
                </button>
              </h3>
              <div
                onClick={() =>
                  setList({ ...list, seventhList: !list.seventhList })
                }
                className={styles.detailicon}
              >
                {list.seventhList && <AddIcon />}
                {!list.seventhList && <CloseIcon />}
              </div>
            </div>

            <Divider style={{ color: "#CECECD" }} />
            <SubsidiaryConfigSection
              groupInformation={groupConfigInformation}
              display={list.seventhList}
              subdiaryInfo={businessDetails}
            />
          </div> */}

          {/* <div className={styles.detailBox}>
            <div className={styles.detailBoxCorner}>
              <h3 className={styles.detailh3}>Preferences</h3>
              <div
                onClick={() =>
                  setList({ ...list, subPreference: !list.subPreference })
                }
                className={styles.detailicon}
              >
                {list.subPreference && <AddIcon />}
                {!list.subPreference && <CloseIcon />}
              </div>
            </div>

            <Divider style={{ color: "#CECECD" }} />
            <SubsidiaryPreferenceSection
              groupInformation={groupConfigInformation}
              display={list.subPreference}
              subdiaryInfo={businessDetails}
            />
          </div> */}

          <div className={styles.detailBox}>
            {/* <div className={styles.detailBoxCorner}>
              <h3 className={styles.detailh3}>Terms and conditions</h3>
              <div
                onClick={() => setList({ ...list, eightList: !list.eightList })}
                className={styles.detailicon}
              >
                {list.eightList && <AddIcon />}
                {!list.eightList && <CloseIcon />}
              </div>
            </div> */}

            {/* <Divider style={{ color: "#CECECD" }} /> */}
            {/* <div
              style={{
                padding: "24px 24px",
                display: list.eightList ? "" : "none",
              }}
            >
              <Grid>
                <div className={styles.accept}>
                  <div className={styles.accept_top}>
                    <h4>Kindly accept the terms and conditions to proceed</h4>{" "}
                    <Exclaim />
                  </div>

                  <div className={styles.accept_top}>
                    <Checkbox
                      checked={accepted}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setAccepted(event.target.checked)
                      }
                      sx={{
                        color: "#19943c",
                        "&.Mui-checked": {
                          color: "#69b088",
                        },
                      }}
                      // disabled
                    />
                    <h3>
                      {profileCompliance?.businessName} accepted the Payinvert
                      Business terms and conditions
                    </h3>
                  </div>
                </div>
              </Grid>
            </div> */}

            <Modal
              isOpen={isViewDetails}
              onRequestClose={() => setIsViewDetails(!isViewDetails)}
              contentLabel='Example Modal'
              style={viewDetailsModalStyles as any}
            >
              <ViewDetails
                closeModal={() => setIsViewDetails(!isViewDetails)}
                openState={isViewDetails}
                id={id}
              />
            </Modal>

            <Modal
              isOpen={modalIsOpenSingle}
              onRequestClose={closeModalSingle}
              contentLabel='Example Modal'
              style={customStyles}
            >
              <Verify closeModal={closeModalSingle} fn={fetchDetails} id={id} />
            </Modal>
            <Modal
              isOpen={documentModalIsOpenSingle}
              onRequestClose={closeDocumentModalSingle}
              contentLabel='Example Modal'
              style={computeCustomStyles()}
            >
              <UploadAdditionalDocument
                closeModal={closeDocumentModalSingle}
                fn={fetchDetails}
                id={id}
              />
            </Modal>
            <Modal
              isOpen={openDetailsUpdateModal.isOpen}
              onRequestClose={() => closeDetailsUpdateModal()}
              contentLabel='Example Modal 1'
              style={customStyles}
            >
              <UpdateDetailModal
                closeModal={closeDetailsUpdateModal}
                fieldName={openDetailsUpdateModal.fieldName}
                fn={fetchDetails}
                id={id}
              />
            </Modal>
            <Modal
              isOpen={openCustomizeConfigModal}
              onRequestClose={() => setOpenCustomizeConfigModal(false)}
              contentLabel='Example Modal 1'
              style={computeCustomStyles()}
            >
              {/* <UpdateSubsidiaryConfigModal
                groupInformation={groupConfigInformation}
                subsidiary={businessInformation}
                closeModal={() => setOpenCustomizeConfigModal(false)}
                cb={fetchDetails}
              /> */}
            </Modal>
          </div>
        </div>
      )}
    </div>
  );
};

export default BusinessDetails;
